import React from 'react';
import { HeartIcon, CalendarIcon, ShareIcon, SparklesIcon } from 'lucide-react';
import { GrowthTimeline } from './GrowthTimeline';
import { HealthHighlights } from './HealthHighlights';
import { TrainingTriumphs } from './TrainingTriumphs';
import { WalksAdventures } from './WalksAdventures';
// Mock data for demonstration purposes
const petData = {
  name: 'Charlie',
  type: 'Dog',
  breed: 'Golden Retriever',
  age: '1 year',
  owner: 'Alex',
  profileImage: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
  yearStartDate: 'January 15, 2023',
  yearEndDate: 'January 15, 2024'
};
export const PetYearThrowback = () => {
  return <div className="w-full min-h-screen bg-gradient-to-b from-amber-50 to-white" data-id="element-57">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-58">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-64 overflow-hidden -z-10" data-id="element-59">
          <div className="absolute -top-10 -left-10 w-32 sm:w-40 h-32 sm:h-40 rounded-full bg-amber-200 opacity-20" data-id="element-60"></div>
          <div className="absolute top-20 right-10 sm:right-20 w-24 sm:w-32 h-24 sm:h-32 rounded-full bg-blue-200 opacity-20" data-id="element-61"></div>
          <div className="absolute top-40 left-1/4 sm:left-1/3 w-16 sm:w-24 h-16 sm:h-24 rounded-full bg-green-200 opacity-20" data-id="element-62"></div>
        </div>
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16 relative" data-id="element-63">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2" data-id="element-64">
            <SparklesIcon className="w-10 h-10 sm:w-12 sm:h-12 text-amber-300" data-id="element-65" />
          </div>
          <div className="relative inline-block mb-6" data-id="element-66">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-300 to-amber-500 rounded-full blur-md opacity-70 scale-110" data-id="element-67"></div>
            <img src={petData.profileImage} alt={`${petData.name} the ${petData.breed}`} className="w-28 h-28 sm:w-36 sm:h-36 rounded-full object-cover border-4 border-white shadow-lg relative z-10" data-id="element-68" />
            <div className="absolute -bottom-2 -right-2 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full p-2 sm:p-3 shadow-md z-20" data-id="element-69">
              <HeartIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-70" />
            </div>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-3 relative" data-id="element-71">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-amber-500 to-amber-700" data-id="element-72">
              {petData.name}'s Year in Review
            </span>
          </h1>
          <div className="inline-flex items-center justify-center gap-2 text-gray-600 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-white shadow-sm text-sm sm:text-base" data-id="element-73">
            <CalendarIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-74" />
            <p className="font-medium" data-id="element-75">
              {petData.yearStartDate} - {petData.yearEndDate}
            </p>
          </div>
          <p className="mt-4 sm:mt-6 text-lg sm:text-xl text-gray-700 max-w-md mx-auto leading-relaxed" data-id="element-76">
            What an incredible journey you and {petData.name} have had together!
          </p>
        </div>
        {/* Main Content */}
        <div className="space-y-10 sm:space-y-16" data-id="element-77">
          <GrowthTimeline petName={petData.name} data-id="element-78" />
          <HealthHighlights petName={petData.name} data-id="element-79" />
          <TrainingTriumphs petName={petData.name} data-id="element-80" />
          <WalksAdventures petName={petData.name} data-id="element-81" />
        </div>
        {/* Footer */}
        <div className="mt-12 sm:mt-20 pt-8 sm:pt-10 text-center relative" data-id="element-82">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 sm:w-24 h-1 bg-gradient-to-r from-amber-300 to-amber-500 rounded-full" data-id="element-83"></div>
          <p className="text-gray-700 mb-6 text-base sm:text-lg" data-id="element-84">
            Here's to another wonderful year with {petData.name}!
          </p>
          <button className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all shadow-md hover:shadow-lg transform hover:-translate-y-1 text-sm sm:text-base" data-id="element-85">
            <ShareIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-86" />
            Share {petData.name}'s Year
          </button>
        </div>
      </div>
    </div>;
};